<template>
    <div class="nested_form">

            <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-25 md-form-label">
                    Name
                </label>
                <div class="md-layout-item" :class="controlsClass">
                    <ValidationProvider name="Contact Full Name" rules="required|min:5|max:100" v-slot="{ passed, failed }">
                        <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                            <md-input v-model="contact.name" placeholder="Full Name" autocomplete="new-contact-name"></md-input>
                            <span class="md-helper-text">Full Name (may be published to websites)</span>
                            <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                            <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                        </md-field>
                    </ValidationProvider>
                </div>
            </div>

            <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-25 md-form-label">
                    Email
                </label>
                <div class="md-layout-item" :class="controlsClass">
                    <ValidationProvider name="Contact Email" rules="email|required|min:5|max:320" v-slot="{ passed, failed }">
                        <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                            <md-input v-model="contact.email" placeholder="Email Address" autocomplete="new-contact-email"></md-input>
                            <span class="md-helper-text">Email (may be published to websites)</span>
                            <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                            <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                        </md-field>
                    </ValidationProvider>
                </div>
            </div>

            <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-25 md-form-label">
                    Telephone
                </label>
                <div class="md-layout-item" :class="controlsClass">
                    <ValidationProvider name="Contact Telephone" :rules="{ required:true, min:11, max:15, regex: /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/ }" v-slot="{ passed, failed }">
                        <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                            <md-input v-model="contact.telephone" placeholder="International Phone Number" autocomplete="new-telephone"></md-input>
                            <span class="md-helper-text">Telephone (may be published to websites) e.g. +441566777888</span>
                            <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                            <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                        </md-field>
                    </ValidationProvider>
                </div>
            </div>

        
    </div>
</template>

<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, min, max, email } from "vee-validate/dist/rules";
    extend("required", required);
    extend("min", min);
    extend("max", max);
    extend("email", email);

    export default {
        name: "ContactInnerDetails",
        components: {
            SlideYDownTransition
        },
        props: {
            contact: {
                name: null,
                email: null,
                telephone: null
            },
            controlsClass: {
                type: String,
                default: () => "md-size-40"
            },
        }
    };
</script>

<style lang="scss">
    .nested_form {
    }
</style>